export default __webpack_public_path__ + "static/media/1-4-1.13ebbb2b.jpg";